import NavBar from '@/components/Nav.vue';

import functions from '@/functions.js';

export default {
    name: 'ComposePage',
    components: {
        NavBar,
    },
    data() {
        return {
            page: 1,
            more: true,
            loading: false,
            exists: [],
            products: [],
            dateFormat: functions.dateFormat
        }
    },
    created() {
        this.getProductList();
    },
    mounted() {
        window.addEventListener('scroll', this.scroll, true);
    },
    unmounted() {
        window.removeEventListener('scroll', this.scroll, true);
    },
    methods: {
        getProductList() {
            if (this.more && ! this.loading) {
                this.loading = true;
                this.$http.get('product/' + this.$route.params.id + '/compose', {params: {page: this.page}}).then(result => {
                    this.page++;
                    this.loading = false;
                    this.more = result.data.more;
                    this.exists = this.products.concat(result.data.exists);
                    this.products = this.products.concat(result.data.products);
                })
            }
        },
        isLack(needs) {
            for (let index in needs) {
                if (this.exists.indexOf(needs[index].id) == -1) {
                    return true;
                }
            }
            return false;
        },
        scroll() {
            let scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
            if (document.documentElement.scrollHeight - scrollTop - document.documentElement.clientHeight <= 100) {
                this.getProductList();
            }
        }
    }
}